import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { 
  FaLaptopCode, FaPencilRuler, FaRegLightbulb, 
} from 'react-icons/fa';
import logo from '../images/olewin.png';

const StudioPage = () => {
  return (
    <>

      
      {/* Hero Section */}
      <section className="studio-hero py-5 mt-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <div className="d-flex align-items-center mb-3">
                <img src={logo} alt="OLEWIN Studio Logo" className="studio-logo me-3" style={{ width: '50px', height:'50px' }} />
                <h1 className="display-6 fw-bold text-primary">Studio</h1>
              </div>
              <h2 className="h3 mb-4">Where Technology Meets Creativity</h2>
              <p className="lead mb-4">
                OLEWIN Studio is our creative and development hub where we bring innovative ideas to life.
                We combine cutting-edge technology with creative design to deliver exceptional digital solutions.
              </p>
              <div className="d-flex flex-wrap gap-3">
                <Button variant="primary" href="/studio_page" size="lg">Continue to Studio</Button>
                <Button variant="outline-dark" href="/contact_studio" size="lg">Contact Studio</Button>
              </div>
            </Col>
            <Col lg={6}>
              <div className="position-relative studio-hero-image">
                <div className="bg-primary rounded-3 p-4 shadow">
                  <div className="studio-mockup bg-white rounded-3 p-3 shadow">
                    <div className="studio-mockup-header d-flex align-items-center mb-3">
                      <div className="studio-mockup-dots">
                        <span className="dot bg-danger"></span>
                        <span className="dot bg-warning"></span>
                        <span className="dot bg-success"></span>
                      </div>
                      <div className="studio-mockup-address bg-light flex-grow-1 ms-3 rounded-pill">
                        <div className="px-3 py-1 text-muted small fw-bold">
                        <img src={logo} alt="OLEWIN Studio Logo" className="studio-logo me-1" style={{ width: '30px', height:'30px' }} /> Studio

                        </div>
                      </div>
                    </div>
                    <div className="studio-mockup-content">
                      <div className="studio-code-preview bg-dark text-light p-3 rounded-3">
                        <pre className="m-0">
                          <code>
                            <span className="text-primary">import</span> React <span className="text-primary">from</span> <span className="text-success">'react'</span>;<br/>
                            <br/>
                            <span className="text-primary">const</span> <span className="text-warning">OLEWINStudio</span> = () =&gt; {`{`}<br/>
                            &nbsp;&nbsp;<span className="text-primary">return</span> (<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&lt;<span className="text-danger">div</span>&gt;<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Creating amazing digital experiences<br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&lt;/<span className="text-danger">div</span>&gt;<br/>
                            &nbsp;&nbsp;);<br/>
                            {`}`};<br/>
                            <br/>
                            <span className="text-primary">export</span> <span className="text-primary">default</span> <span className="text-warning">Olewin Studio</span>;
                          </code>
                        </pre>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* Services Section */}
      <section className="studio-services py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5">Studio Services</h2>
          <Row className="g-4">
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm studio-card">
                <Card.Body className="p-4">
                  <div className="studio-icon-wrapper mb-4">
                    <FaLaptopCode className="studio-icon" />
                  </div>
                  <Card.Title>Web Development</Card.Title>
                  <Card.Text>
                    Custom web applications, responsive websites, and progressive web apps built with the latest technologies.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm studio-card">
                <Card.Body className="p-4">
                  <div className="studio-icon-wrapper mb-4">
                    <FaPencilRuler className="studio-icon" />
                  </div>
                  <Card.Title>UI/UX Design</Card.Title>
                  <Card.Text>
                    User-centered design with intuitive interfaces that create memorable digital experiences.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4}>
              <Card className="h-100 border-0 shadow-sm studio-card">
                <Card.Body className="p-4">
                  <div className="studio-icon-wrapper mb-4">
                    <FaRegLightbulb className="studio-icon" />
                  </div>
                  <Card.Title>Digital Innovation</Card.Title>
                  <Card.Text>
                    Transforming ideas into reality with creative problem-solving and innovative technologies.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* Process Section */}
      <section className="studio-process py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={5} className="mb-4 mb-lg-0">
              <h2 className="mb-4">Our Studio Process</h2>
              <p className="lead mb-4">
                We follow a proven methodology to ensure every project delivers exceptional results.
              </p>
              <div className="studio-process-step d-flex align-items-start mb-4">
                <div className="studio-process-number">1</div>
                <div className="ms-3">
                  <h5>Discovery & Planning</h5>
                  <p className="text-muted">Understanding your needs, goals, and defining project requirements.</p>
                </div>
              </div>
              <div className="studio-process-step d-flex align-items-start mb-4">
                <div className="studio-process-number">2</div>
                <div className="ms-3">
                  <h5>Design & Prototyping</h5>
                  <p className="text-muted">Creating visual concepts and interactive prototypes.</p>
                </div>
              </div>
              <div className="studio-process-step d-flex align-items-start">
                <div className="studio-process-number">3</div>
                <div className="ms-3">
                  <h5>Development</h5>
                  <p className="text-muted">Bringing designs to life with clean, efficient code.</p>
                </div>
              </div>
            </Col>
            <Col lg={7}>
              <div className="studio-process-image p-3 bg-white rounded-3 shadow">
                <img 
                  src="/api/placeholder/700/400" 
                  alt="Studio Process" 
                  className="img-fluid rounded-3" 
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* Team Section */}
      <section className="studio-team py-5 bg-light">
        <Container>
          <h2 className="text-center mb-5">Our Studio Team</h2>
          <Row className="g-4">
            <Col md={6} lg={3}>
              <Card className="border-0 shadow-sm studio-team-card text-center h-100">
                <Card.Body className="p-4">
                  <div className="studio-team-avatar mb-3">
                    <img 
                      src="/api/placeholder/150/150" 
                      alt="Team Member" 
                      className="rounded-circle img-fluid" 
                    />
                  </div>
                  <Card.Title>Alex Johnson</Card.Title>
                  <p className="text-primary mb-2">Creative Director</p>
                  <Card.Text className="text-muted">
                    10+ years of experience in digital product design and branding.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="border-0 shadow-sm studio-team-card text-center h-100">
                <Card.Body className="p-4">
                  <div className="studio-team-avatar mb-3">
                    <img 
                      src="/api/placeholder/150/150" 
                      alt="Team Member" 
                      className="rounded-circle img-fluid" 
                    />
                  </div>
                  <Card.Title>Sarah Lee</Card.Title>
                  <p className="text-primary mb-2">Lead Developer</p>
                  <Card.Text className="text-muted">
                    Full-stack developer with expertise in React and Node.js.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="border-0 shadow-sm studio-team-card text-center h-100">
                <Card.Body className="p-4">
                  <div className="studio-team-avatar mb-3">
                    <img 
                      src="/api/placeholder/150/150" 
                      alt="Team Member" 
                      className="rounded-circle img-fluid" 
                    />
                  </div>
                  <Card.Title>Michael Chen</Card.Title>
                  <p className="text-primary mb-2">UX Specialist</p>
                  <Card.Text className="text-muted">
                    Expert in creating user-centered designs and experiences.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="border-0 shadow-sm studio-team-card text-center h-100">
                <Card.Body className="p-4">
                  <div className="studio-team-avatar mb-3">
                    <img 
                      src="/api/placeholder/150/150" 
                      alt="Team Member" 
                      className="rounded-circle img-fluid" 
                    />
                  </div>
                  <Card.Title>Rachel Kim</Card.Title>
                  <p className="text-primary mb-2">Product Manager</p>
                  <Card.Text className="text-muted">
                    Specializes in guiding products from concept to completion.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* CTA Section */}
      <section className="studio-cta py-5 bg-primary text-white">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h2 className="mb-4">Ready to bring your ideas to life?</h2>
              <p className="lead mb-4">
                Let's work together to create something amazing. Contact OLEWIN Studio today to start the conversation.
              </p>
              <Button variant="light" size="lg" className="px-4 py-2">
                Contact Studio
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* Featured Work */}
      <section className="studio-work py-5">
        <Container>
          <h2 className="text-center mb-5">Featured Work</h2>
          <Row className="g-4">
            <Col md={6} lg={4}>
              <div className="studio-work-item position-relative">
                <img 
                  src="/api/placeholder/400/300" 
                  alt="Project" 
                  className="img-fluid rounded-3" 
                />
                <div className="studio-work-overlay rounded-3">
                  <div className="studio-work-content">
                    <h5>E-Commerce Platform</h5>
                    <p className="mb-0">Web Development, UI/UX</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="studio-work-item position-relative">
                <img 
                  src="/api/placeholder/400/300" 
                  alt="Project" 
                  className="img-fluid rounded-3" 
                />
                <div className="studio-work-overlay rounded-3">
                  <div className="studio-work-content">
                    <h5>Mobile Banking App</h5>
                    <p className="mb-0">Mobile Development, UX Design</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={6} lg={4}>
              <div className="studio-work-item position-relative">
                <img 
                  src="/api/placeholder/400/300" 
                  alt="Project" 
                  className="img-fluid rounded-3" 
                />
                <div className="studio-work-overlay rounded-3">
                  <div className="studio-work-content">
                    <h5>Healthcare Dashboard</h5>
                    <p className="mb-0">Data Visualization, UI Design</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <div className="text-center mt-5">
            <Button variant="outline-primary" size="lg">View All Work</Button>
          </div>
        </Container>
      </section>
      
    
    </>
  );
};

export default StudioPage;